export default __webpack_public_path__ + "static/media/instagram.78f29687.svg";